import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

function savedTheme () {
  try {
    return localStorage.getItem('tapapp-theme') === 'dark' ? 'dark' : 'light'
  } catch (err) {
    return 'light'
  }
}

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  theme: {
    defaultTheme: savedTheme(),
    themes: {
      light: {
        colors: {
          primary: '#71439b',
          background: '#FFFFFF',
          surface: '#FFFFFF'
        }
      },
      dark: {
        colors: {
          primary: '#71439b',
          background: '#0E0A15',
          surface: '#181121'
        }
      }
    }
  }
})
